import type React from 'react';

const withDisplayName = <P extends object>(
  component: React.FC<P>,
  displayName: string
): React.FC<P> => {
  return Object.defineProperty(component, 'displayName', { value: displayName });
};

export default withDisplayName;
